export default class DeleteAccPopup {
    constructor() {
        $('.js-open-delete-acc-popup').on('click', this.showPopup.bind(this));
        this.deleteAccFormBind();
        this.$modal = $('.js-delete-acc-modal');
        this.$errorEl = this.$modal.find('.js-delete-acc-modal__error');
        this.$mainBody = this.$modal.find('.js-modal-body--main')
        this.$successContentBody = this.$modal.find('.js-modal-body--success');
        this.$modal.on("hide.bs.modal", function() {
            BX.closeWait();
	    })

    }

    /**
     *
     * @param {ClickEvent} e
     */
    showPopup(e) {
        e.preventDefault();
        $('.js-delete-acc-modal').modal('show');
    }

    /**
     * Привязка экшна удаления аккаунта
     */
    deleteAccFormBind() {
        $('.js-delete-acc-modal form')
            .off('submit')
            .on('submit', this.submit.bind(this));
    }

    /**
     *
     * @param {SubmitEvent} e
     */
    submit(e) {
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        this.hideError();

        BX.ajax.runComponentAction('webgk:account_delete',
            'checkDeleteAccount', {
                mode: 'class',
                signedParameters: [],
                data: {
                    email: formData.get('USER_EMAIL'),
                },
            })
            .then(response => {

                if(!response.data.ERROR) {
                    setTimeout(()=>{
                        BX.showWait();
                    },200)
                }
                const isOrdersDeleted = this.runUnbindOrders.call(this, response);
            })
    }

    /**
     * Запускаем процесс итеративной отвязки заказов (обычных и архивных)
     * @param response
     * @returns {*}
     */
    runUnbindOrders(response) {
        const data = response.data;
        if (!data.ERROR && !data.FINISHED && !!data.LIMIT) {
            this.hideError();

            BX.ajax.runComponentAction(
                'webgk:account_delete',
                'iterateUnbindOrders', {
                    mode: 'class',
                    signedParameters: [],
                }
            ).then(response => {
                    this.runUnbindOrders.call(this, response);
                }
            )

        } else if (data.ERROR) {
            this.showError.call(this, data.ERROR);
            return response;
        } else if (data.SUCCESS) {//after user deletion
            BX.closeWait();
            this.showSuccess();
            setTimeout(() => {
                window.location.href = '/';
            }, 2000)

        } else {
            console.error('Unexpected error occurred.');//this should not log
        }
    }

    /**
     *
     * @param {string} text
     */
    showError(text) {
        this.$errorEl.text(text);
        this.$errorEl.addClass('show');
        this.$errorEl.removeClass('hidden');

    }

    /**
     * Скрыть ошибку
     */
    hideError() {
        this.$errorEl.removeClass('show');
        this.$errorEl.addClass('hidden');
    }

    /**
     * После удаления акка показываем сообщение об успешном удалении
     */
    showSuccess() {
        this.$mainBody.hide();
        this.$successContentBody.removeAttr('hidden');
    }
}
